<template>
    <form-container :headerText="title" :width="400" action="editSaison"
                    :valid-actions="['editSaison']" @save="save()">
        <div v-if="rules" class="px-7 pb-3">
            <v-text-field v-model="dataObject.anzahlSpieler" :rules="[rules.required]"
                          label="Anzahl Spieler pro Mannschaft" type="number" :disabled="editBlock">
            </v-text-field>
            <v-text-field v-model="dataObject.anzahlErsatzSpieler" :rules="[rules.required]"
                          label="Anzahl Ersatzspieler pro Mannschaft" type="number"
                          :disabled="editBlock && !isAnzahlErsatzspielerChangeable">
            </v-text-field>
            <v-checkbox v-model="dataObject.eintauschVorEinspielzeit" :disabled="editBlock"
                        label="Eintausch vor Einspielzeit erlaubt" color="primary" hide-details>
            </v-checkbox>
            <v-checkbox v-model="dataObject.freieSpieler" :disabled="editBlock"
                        label="Spieler ohne Pass oder Vereinszugehörigkeit erlaubt" color="primary">
            </v-checkbox>
            <div v-if="dataObject.getCountOfTabPosColors() > 0 && !isCup">
                <span class="caption grey--text text--darken-1">Tabellenposition</span>
                <v-row v-for="(saisontabPosColor, i) in currentColorDuplicate" :key="i"
                        class="align-center mt-1 mb-3">
                    <v-col cols="4" class="py-0">
                        <div :class="[saisontabPosColor.color,
                                      'py-2 mb-0 mt-1 px-5 d-inline-block subtitle-1 text-center']"
                                style="border-radius: 4px; width: 100%">
                            {{saisontabPosColor.tabPos}}</div>
                    </v-col>
                    <v-col cols="6" class="py-0">
                        <v-select v-model="saisontabPosColor.color" :items="tabPosColors"
                                  @change="changeColor(saisontabPosColor)"
                                  label="Hintergrundfarbe" class="d-inline-block" hide-details>
                            <template v-slot:item="{ item }">
                                <span :class="['py-1 px-3', item.value]"
                                      style="border-radius: 4px; ">{{item.text}}</span>
                            </template>
                        </v-select>
                    </v-col>
                    <v-col cols="2" class="py-0">
                        <v-btn icon @click="deleteTabPosColor(saisontabPosColor.tabPos)">
                            <v-icon>mdi-trash-can-outline</v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
            </div>
            <v-row v-if="!isCup">
                <v-col cols="4">
                    <v-text-field v-model="tabPosColor.tabPos" label="Tabellenposition" type="number"
                                  @change="setTabPosColor()"></v-text-field>
                    <!--<v-select v-model="tabPosColor.tabPos" :items="dataObject.getTabellenPosList()"
                              label="Tabellenposition" @change="setTabPosColor()"></v-select>-->
                </v-col>
                <v-col cols="8">
                    <v-select v-model="tabPosColor.color" :items="tabPosColors"
                              label="Hintergrundfarbe" @change="setTabPosColor()">
                        <template v-slot:item="{ item }">
                             <span :class="['py-1 px-3', item.value]">{{item.text}}</span>
                        </template>
                    </v-select>
                </v-col>
            </v-row>
            <error-msg :error="error"></error-msg>
            <!--<p>currentData: {{currentData}}</p>
            <p>ligaId: {{ligaId}}</p>
            <p>sportJahr: {{sportJahr}}</p>-->
        </div>
    </form-container>
</template>

<script>
    import FormContainer from "../../components/form/formContainer";
    import {FormRules} from "../../services/formRules";
    import ErrorMsg from "../../components/elements/errorMsg";
    import {Saison} from "../../services/data/saison";
    import {db} from "../../services/db";

    export default {
        components: { ErrorMsg, FormContainer},
        name: "saison-edit",
        props: ['currentData', 'ligaId', 'isCup', 'sportJahr'],
        data: () => ({
            rules: null,
            dataObject: null,
            error: '',
            tabPosColor: {tabPos: null, color: ''},
            tabPosColors: [
                {text: 'dunkelgrün', value: 'green darken-4 white--text'},
                {text: 'hellgrün', value: 'green lighten-5'},
                {text: 'orange', value: 'orange lighten-4'},
                {text: 'rot', value: 'red darken-2 white--text'},
            ],
            currentColorDuplicate: []
        }),
        computed: {
            types(){ return this.$store.state.local.ligaTypes;},
            sportJahrText(){ return this.sportJahr.replace('_', '/') },
            title(){ return this.currentData ? 'Saison ' + this.sportJahrText + ' ändern' :
                                               'Saison ' + this.sportJahrText + ' anlegen'},
            editBlock(){ return Object.keys(this.dataObject.spiele).length > 0;},
            isAnzahlErsatzspielerChangeable(){ return this.dataObject ? this.dataObject.isAnzahlErsatzspielerChangeable() : false},
        },
        created(){
            this.rules = new FormRules();
            this.dataObject = new Saison();
            if ( this.currentData ) {
                this.dataObject.setFromDataObject(this.currentData);
                this.currentColorDuplicate = this.dataObject.getTabPosColorList();
            }
        },
        methods: {
            changeColor(saisontabPosColor) {
                this.dataObject.tabellenFarben[saisontabPosColor.tabPos] = saisontabPosColor.color;
            },
            setTabPosColor(){
                if ( this.tabPosColor.tabPos !== null && this.tabPosColor.color ) {
                    this.dataObject.tabellenFarben[this.tabPosColor.tabPos] = this.tabPosColor.color;
                    this.currentColorDuplicate.push(JSON.parse(JSON.stringify(this.tabPosColor)));
                    this.tabPosColor.tabPos = null;
                    this.tabPosColor.color = null;
                }
            },
            deleteTabPosColor(tabPos){
                this.dataObject.deleteTabPosColor(tabPos);
                for ( let i = 0; i <  this.currentColorDuplicate.length; i++ ) {
                    if ( this.currentColorDuplicate[i].tabPos === tabPos ) {
                        this.currentColorDuplicate.splice(i, 1)
                    }
                }
            },
            async save(){
                this.dataObject.isCup = this.isCup;
                this.dataObject.anzahlSpieler = parseInt(this.dataObject.anzahlSpieler);
                this.dataObject.anzahlErsatzSpieler = parseInt(this.dataObject.anzahlErsatzSpieler);
                this.$store.state.local.loader = true;
                if ( this.currentData ) {
            // edit existing
                // checks to be implemented (changes allowed)
                // update
                    if ( this.dataObject.setDocumentUpdates(this.currentData) ) {
                        let reply = await this.dataObject.saveEdited('saison_edit');
                        if ( reply.successful ) {
                            this.changeErsatzspielerInSpiel();
                            window.history.back();
                        } else {
                            this.error = this.dataObject.getDBErrorText(reply.content);
                        }
                    } else {
                        window.history.back();
                    }
                } else {
                // create new
                    // set data
                    this.dataObject.id = this.ligaId + '_' + this.sportJahr;
                    this.dataObject.ligaId = this.ligaId;
                    this.dataObject.lvId = this.ligaId.split('_')[0];
                    this.dataObject.sportJahr = this.sportJahr;
                    // create in db
                    let reply = await this.dataObject.saveNew('document');
                    if ( reply.successful ) {
                        const id = reply.content;
                        const collection = "saisonen/" + id + '/schnittliste';
                        db.collection(collection).doc(id + "F").set({spiele: {}});
                        db.collection(collection).doc(id + "H").set({spiele: {}});
                        window.history.back();
                    } else {
                        this.error = this.dataObject.getDBErrorText(reply.content);
                    }
                }
                this.$store.state.local.loader = false;
            },
            async changeErsatzspielerInSpiel(){
                if ( this.isAnzahlErsatzspielerChangeable &&
                     this.dataObject.local.documentUpdates.anzahlErsatzSpieler !== undefined &&
                     Object.keys(this.dataObject.spiele).length > 0) {
                    const ersatzSpielerObjekt = this.dataObject.getEmptyErsatzspielerObjekt();
                    let batch = db.batch();
                    Object.keys(this.dataObject.spiele).forEach( (spielId) => {
                        //console.log ("YYYYYYYYYYYYYYYYYYYY", spielId, ersatzSpielerObjekt);
                        batch.update(db.collection("spiele").doc(spielId), ersatzSpielerObjekt);
                    });
                    await batch.commit();
                }
            }
        },
    }
</script>

<style scoped>

</style>